import { motion } from 'framer-motion'

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center"
      style={{ background: 'var(--bg-primary)' }}>
      {/* Ambient glow */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full blur-[120px]"
          style={{ background: 'rgba(255,107,0,0.04)' }} />
      </div>

      {/* Logo pulse */}
      <motion.div
        animate={{ scale: [1, 1.08, 1], opacity: [0.7, 1, 0.7] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        className="mb-6"
      >
        <img src="/LOGO-dark.png" alt="Perceptrons" className="h-16 w-auto"
          style={{ filter: 'drop-shadow(0 0 20px rgba(255,107,0,0.15))' }} />
      </motion.div>

      {/* Spinner ring */}
      <div className="relative w-12 h-12 mb-4">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
          className="absolute inset-0 rounded-full"
          style={{
            border: '2px solid transparent',
            borderTopColor: 'var(--brand-primary)',
            borderRightColor: 'var(--brand-accent)',
          }}
        />
        <motion.div
          animate={{ rotate: -360 }}
          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
          className="absolute inset-1.5 rounded-full"
          style={{
            border: '1px solid transparent',
            borderTopColor: 'var(--brand-primary)',
            opacity: 0.4,
          }}
        />
      </div>

      {/* Loading text */}
      <motion.p
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
        className="text-xs font-medium tracking-widest uppercase"
        style={{ color: 'var(--text-muted)' }}
      >
        Loading
      </motion.p>
    </div>
  )
}
